
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fKZKi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9fb5e6c964241e04$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $9fb5e6c964241e04$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "\u30AA\u30EA\u30B8\u30CA\u30EB\u306E\u7D75\u6587\u5B57\u3092\u8FFD\u52A0",
    'fabric.emoji.add.label': "\u7D75\u6587\u5B57\u3092\u8FFD\u52A0",
    'fabric.emoji.cancel.label': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'fabric.emoji.categories.label': "\u7D75\u6587\u5B57\u306E\u30AB\u30C6\u30B4\u30EA\u3092\u9078\u629E",
    'fabric.emoji.categories.search.results': "\u691C\u7D22\u7D50\u679C",
    'fabric.emoji.category.activity': "\u30A2\u30AF\u30C6\u30A3\u30D3\u30C6\u30A3",
    'fabric.emoji.category.all.uploads': "\u3059\u3079\u3066\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
    'fabric.emoji.category.flags': "\u65D7",
    'fabric.emoji.category.foods': "\u30D5\u30FC\u30C9 & \u30C9\u30EA\u30F3\u30AF",
    'fabric.emoji.category.frequent': "\u3088\u304F\u4F7F\u3046\u3082\u306E",
    'fabric.emoji.category.nature': "\u81EA\u7136",
    'fabric.emoji.category.objects': "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8",
    'fabric.emoji.category.people': "\u4EBA",
    'fabric.emoji.category.places': "\u65C5\u884C & \u5834\u6240",
    'fabric.emoji.category.productivity': "\u30E2\u30CE\u4F5C\u308A",
    'fabric.emoji.category.symbols': "\u8A18\u53F7",
    'fabric.emoji.category.user.uploads': "\u3042\u306A\u305F\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
    'fabric.emoji.choose.file.screenReaderDescription': "\u7D75\u6587\u5B57\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u9078\u629E\u3067\u304D\u308B\u30D5\u30A1\u30A4\u30EB\u306F JPG\u3001PNG\u3001GIF \u306E\u5404\u5F62\u5F0F\u3067\u3001\u30B5\u30A4\u30BA\u5236\u9650\u306F\u6700\u5927 1 MB \u3067\u3059",
    'fabric.emoji.choose.file.title': "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E",
    'fabric.emoji.delete.description': "\u3053\u306E\u7D75\u6587\u5B57\u306E\u3059\u3079\u3066\u306E\u65E2\u5B58\u306E\u30A4\u30F3\u30B9\u30BF\u30F3\u30B9\u3092{emojiShortName}\u3068\u7F6E\u304D\u63DB\u3048\u307E\u3059",
    'fabric.emoji.delete.label': "\u524A\u9664",
    'fabric.emoji.delete.screenreader.tooltip': "{shortName} \u306E\u7D75\u6587\u5B57\u3092\u524A\u9664\u3059\u308B\u306B\u306F\u3001Backspace \u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059",
    'fabric.emoji.delete.title': "\u7D75\u6587\u5B57\u3092\u524A\u9664",
    'fabric.emoji.delete.tooltip': "\u524A\u9664",
    'fabric.emoji.emojipicker.emoi.roledescription': "\u7D75\u6587\u5B57\u30DC\u30BF\u30F3",
    'fabric.emoji.emojipicker.error': "\u30A8\u30E9\u30FC!",
    'fabric.emoji.error.delete.failed': "\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'fabric.emoji.error.image.too.big': "\u9078\u629E\u3057\u305F\u753B\u50CF\u306F 1 MB \u3092\u8D85\u3048\u3066\u3044\u307E\u3059",
    'fabric.emoji.error.invalid.image': "\u9078\u629E\u3057\u305F\u753B\u50CF\u306F\u7121\u52B9\u3067\u3059\u3002",
    'fabric.emoji.error.upload.failed': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'fabric.emoji.error.upload.timeout': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8",
    'fabric.emoji.image.requirements': "JPG\u3001PNG\u3001GIF\u3002\u6700\u5927\u30B5\u30A4\u30BA 1 MB\u3002",
    'fabric.emoji.name.ariaLabel': "\u65B0\u3057\u3044\u7D75\u6587\u5B57\u306E\u540D\u524D\u3092\u5165\u529B\u3059\u308B",
    'fabric.emoji.picker': "\u7D75\u6587\u5B57\u30D4\u30C3\u30AB\u30FC",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {\u7D50\u679C\u3092\u691C\u7D22} other {\u7D75\u6587\u5B57}}",
    'fabric.emoji.pickerlist.tabpanel': "\u7D75\u6587\u5B57\u30A2\u30AF\u30B7\u30E7\u30F3\u3068\u30EA\u30B9\u30C8 \u30D1\u30CD\u30EB",
    'fabric.emoji.placeholder': "\u4F8B: \u3053\u3093\u306B\u3061\u306F",
    'fabric.emoji.preview': "\u65B0\u3057\u3044\u7D75\u6587\u5B57{emoji}\u306F\u7D20\u6575\u3067\u3059\u306D",
    'fabric.emoji.preview.title': "\u30D7\u30EC\u30D3\u30E5\u30FC",
    'fabric.emoji.retry.label': "\u518D\u8A66\u884C",
    'fabric.emoji.search.label': "\u7D75\u6587\u5B57\u306E\u540D\u524D",
    'fabric.emoji.search.placeholder': "\u691C\u7D22",
    'fabric.emoji.search.status': "\u3059\u3079\u3066\u306E\u7D75\u6587\u5B57\u3092\u8868\u793A",
    'fabric.emoji.select.skin.list.ariaLabel': "\u30B9\u30AD\u30F3 \u30C8\u30FC\u30F3 \u30BB\u30EC\u30AF\u30BF\u30FC",
    'fabric.emoji.select.skin.tone.ariaLabel': "\u30B9\u30AD\u30F3 \u30C8\u30FC\u30F3\u3092\u3054\u9078\u629E\u304F\u3060\u3055\u3044\u3002{selectedTone} \u3092\u9078\u629E\u6E08\u307F"
};

});


//# sourceMappingURL=ja.61a9fb08.js.map
